export default {
  registerFormPaginated: (state) => state.registerFormPaginated,
  registerFormColumnsNames:(state) => state.registerFormColumnsNames
};
